// ════════════════════════════════════════════════════════════════════════
// LeadsPage.tsx — Página del panel administrativo de Leads
// ════════════════════════════════════════════════════════════════════════

import { DashboardLayout } from '../layouts/DashboardLayout/DashboardLayout';
import { AppSidebarMenu } from '../components/AppSidebarMenu/AppSidebarMenu';
import { LeadsGrid } from '../features/Leads/LeadsGrid/LeadsGrid';
import styles from './LeadsPage.module.css';

export default function LeadsPage() {
  return (
    <DashboardLayout.Root>
      <DashboardLayout.Sidebar>
        <AppSidebarMenu />
      </DashboardLayout.Sidebar>

      <DashboardLayout.Content>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>Leads</h1>
        </div>

        <LeadsGrid />
      </DashboardLayout.Content>
    </DashboardLayout.Root>
  );
}
